export function StockBadge({ status, sku }) {
  const inStock = status === "in_stock";
  return (
    <span
      data-testid={`product-badge-stock-${sku}`}
      className={`absolute top-3 right-3 text-[10px] font-mono uppercase tracking-wider px-2.5 py-1 rounded-full border backdrop-blur-sm ${
        inStock
          ? "bg-emerald-950/70 text-emerald-300 border-emerald-500/40"
          : "bg-rose-950/70 text-rose-300 border-rose-500/40"
      }`}
    >
      {inStock ? "In Stock" : "Out of Stock"}
    </span>
  );
}
